import React from 'react';
import { Box, Flex, Group } from '@mantine/core';
import DynamicField from './DynamicField';
import { UiField, UiFieldRow } from 'src/UI/dynamicUI/types';

interface DynamicFieldRowProps {
  fieldRow: UiFieldRow;
  index?: number;
}

export default function DynamicFieldRow({ fieldRow, index }: DynamicFieldRowProps) {
  const areLinked = fieldRow.areFieldsLinked;
  const isFieldRow = (field: UiFieldRow | UiField) => field.type === 'FIELD_ROW';
  return (
    <Group grow={!areLinked} gap={areLinked ? 0 : undefined} preventGrowOverflow={false}>
      {fieldRow.children.map((field, i) => (
        <Flex key={i}>
          {isFieldRow(field) ? (
            <DynamicFieldRow fieldRow={field} index={index} />
          ) : (
            <DynamicField field={field} index={index} />
          )}
          {areLinked && i < fieldRow.children.length - 1 && (
            <Flex px={'xxxs'} direction={'row'} align={'center'} style={{ marginTop: 25 }}>
              <Box
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: 6,
                  backgroundColor: '#D6D6D6',
                }}
              />
              <Box
                style={{
                  width: 300,
                  height: 1,
                  backgroundColor: '#D6D6D6',
                }}
              />
              <Box
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: 6,
                  backgroundColor: '#D6D6D6',
                }}
              />
            </Flex>
          )}
        </Flex>
      ))}
    </Group>
  );
}
